// extracted by mini-css-extract-plugin
module.exports = {"navigationMenu":"navigationMenu_navigationMenu__22lcy","navigationItem":"navigationMenu_navigationItem__3njCR","active":"navigationMenu_active__3UPre"};